/* (c) Quick Pro USA (quickprousa.com) - proprietary theme code.
   <qp-pdp-also-looked> — OTHERS ALSO LOOKED AT slot under the buy box on the
   new PDP templates (sections/qp-pdp-also-looked.liquid).

   Same two-pass mechanism as <qp-qs-related> / Minimog's
   <product-recommendations>: the element ships empty (zero height — never
   display:none, an unboxed element defeats IntersectionObserver), then
   fetches its own section through the product recommendations endpoint
   (data-url) once it nears the viewport. The fetched render carries the
   card list; this side removes the excluded ids (the page product, its
   frame, the twin, every part already offered in the buy box —
   data-exclude), trims to data-limit, and reveals only when at least min
   cardss survive (data-min, default 2). Every failure path removes the whole section — never an
   empty heading, never a spacing ghost.

   Zero lime, no payload: this element touches nothing in the cart. */
(() => {
  'use strict';
  if (customElements.get('qp-pdp-also-looked')) return;

  class QpPdpAlsoLooked extends HTMLElement {
    connectedCallback() {
      if (this._alsoInit) return;
      this._alsoInit = true;
      const url = this.getAttribute('data-url');
      if (!url) {
        this._retire();
        return;
      }
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              io.disconnect();
              this._load(url);
            });
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        io.observe(this);
      } else {
        this._load(url);
      }
    }

    async _load(url) {
      try {
        const res = await fetch(url);
        if (!res.ok) {
          this._retire();
          return;
        }
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const body = doc.querySelector('[data-also-body]');
        if (!body) {
          this._retire();
          return;
        }
        const exclude = (this.getAttribute('data-exclude') || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
        const max = parseInt(this.getAttribute('data-limit'), 10) || 4;
        /* one card in a four-column grid reads as a broken row, not a shelf */
        const min = Math.max(1, parseInt(this.getAttribute('data-min'), 10) || 1);
        let kept = 0;
        body.querySelectorAll('[data-product-id]').forEach((li) => {
          const id = li.getAttribute('data-product-id');
          if (exclude.indexOf(id) !== -1 || kept >= max) {
            li.remove();
            return;
          }
          kept += 1;
        });
        if (kept < min) {
          this._retire();
          return;
        }
        this.replaceChildren(body);
        /* paint dots on the injected cards (qp-swatch-color.js scans on load only) */
        if (window.qpSwatchColor && typeof window.qpSwatchColor.scan === 'function') {
          try { window.qpSwatchColor.scan(this); } catch (e) { /* cosmetic */ }
        }
        this.dispatchEvent(new CustomEvent('qp-pdp-also:ready', { bubbles: true, detail: { count: kept } }));
      } catch (err) {
        this._retire();
      }
    }

    /* Nothing to show: remove the whole section so no spacing survives. */
    _retire() {
      const host = this.closest('.qp-pdp-also');
      if (host) host.remove();
      else this.remove();
    }
  }

  customElements.define('qp-pdp-also-looked', QpPdpAlsoLooked);
})();
